import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './LeasingFeedbackCard.css';

class LeasingFeedbackCard extends React.Component {
  static propTypes = {
    avatar: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    rate: PropTypes.number.isRequired,
  };
  static defaultProps = {};
  render() {
    const { avatar, name, text, rate } = this.props;
    return (
      <div className={s.root}>
        <div className={s.content}>
          <div className={s.head}>
            <div className={s.avatar}>
              <img src={avatar} width="50" height="50" alt="" />
            </div>
            <div className={s.name}>
              {name}
            </div>
          </div>
          <div className={s.text}>
            {text}
          </div>
        </div>
        {/* <div className={s.footer}>
          <hr className={s.divider} />
          <div className={s.rate}>
            {text}
          </div> 
        </div> */}
      </div>
    );
  }
}

export default withStyles(s)(LeasingFeedbackCard);



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingFeedback/LeasingFeedbackCard/LeasingFeedbackCard.js